import { render, staticRenderFns } from "./ResetPage.vue?vue&type=template&id=7eaaf83b"
import script from "./ResetPage.vue?vue&type=script&lang=js"
export * from "./ResetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports